import { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import api from "@/lib/api";

const SEEN_KEY = "sc_featured_event_seen";

const hasSeenToday = (updatedAt) => {
  try {
    const raw = localStorage.getItem(SEEN_KEY);
    if (!raw) return false;
    const seen = JSON.parse(raw);
    return seen.updatedAt === updatedAt && seen.day === new Date().toDateString();
  } catch (_) {
    return false;
  }
};

const markSeen = (updatedAt) => {
  try {
    localStorage.setItem(SEEN_KEY, JSON.stringify({ updatedAt, day: new Date().toDateString() }));
  } catch (_) {}
};

export const FeaturedEventModal = ({ onSettled }) => {
  const [event, setEvent] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    api.get("/featured-event").then((res) => {
      if (!mounted) return;
      const data = res.data;
      if (data?.enabled && data?.show_as_modal && !hasSeenToday(data.updated_at)) {
        setEvent(data);
        window.setTimeout(() => setOpen(true), 600);
      } else {
        onSettled?.();
      }
    }).catch(() => { if (mounted) onSettled?.(); });
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const close = () => {
    setOpen(false);
    if (event) markSeen(event.updated_at);
    onSettled?.();
  };

  const handleCta = () => {
    const link = event?.button_link || "#eventos";
    close();
    window.setTimeout(() => {
      if (link.startsWith("#")) {
        document.querySelector(link)?.scrollIntoView({ behavior: "smooth" });
        return;
      }
      if (link.startsWith("/")) {
        window.location.href = link;
        return;
      }
      window.open(link, "_blank", "noopener,noreferrer");
    }, 250);
  };

  if (!event) return null;

  const imageSrc = event.image_data || event.image_url || null;
  const mobileImageSrc = event.mobile_image_data || event.mobile_image_url || imageSrc;

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) close(); }}>
      <DialogContent
        className="max-w-md overflow-hidden border-white/10 bg-[#0A0A0A] p-0 sm:max-w-lg"
        data-testid="featured-event-modal"
      >
        {imageSrc && (
          <div className="relative aspect-[16/10] w-full overflow-hidden bg-black">
            <img src={imageSrc} alt={event.title || "Evento"} className="hidden h-full w-full object-cover md:block" />
            <img src={mobileImageSrc} alt={event.title || "Evento"} className="block h-full w-full object-cover md:hidden" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
          </div>
        )}
        <div className="space-y-4 p-6 pt-4">
          {event.title && (
            <h2 className="font-['Cormorant_Garamond'] text-2xl text-white sm:text-3xl">{event.title}</h2>
          )}
          {event.description && (
            <p className="font-['Manrope'] text-sm font-light leading-relaxed text-white/70">{event.description}</p>
          )}
          {event.button_text && (
            <button
              type="button"
              onClick={handleCta}
              className="hero-cta-premium w-full cursor-pointer px-6 py-3 font-['Manrope'] text-xs uppercase tracking-[0.18em]"
              data-testid="featured-event-cta"
            >
              {event.button_text}
            </button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
